import {
  addMessage,
  AddMessageAction,
  removeMessage,
  RemoveMessageAction,
  ReactionPayload,
  addMessageReactionSuccess,
  removeMessageReactionSuccess,
  DeleteMessageStatusAction,
  deleteMessageStatus,
} from "actions/conversationInbox";

import { Store } from "../../store";
import {
  CollaborationApi,
  PolicyEnforcementPayload,
  PUSHER_EVENTS,
} from "../../api/collaboration";

import { User } from "features/user/types";
import { updateAccount } from "actions/commonActions";
import { Channel } from "pusher-js";
import { hasInboxPermission } from "utils/user";

export class PusherClient {
  static #instance: PusherClient;

  user: User;
  collabApi: CollaborationApi | undefined;
  channel: Channel | undefined;

  constructor(user: User) {
    const channelId = `private-inbox-${user.adminId}`;
    this.user = user;
    this.collabApi = new CollaborationApi();
    this.collabApi
      .subscribe(channelId, true)
      .then((channel: Channel) => {
        this.channel = channel;
        // Inbox message events trigger skedInboxApi fetches (conversation +
        // counters). For collaborators without inbox access those calls 403, so
        // only bind them when permitted. The account policy-enforcement events
        // below apply to every user.
        if (hasInboxPermission(user)) {
          channel.bind(
            PUSHER_EVENTS.INBOX_MESSAGE_ADDED,
            this.newMessageAddedEvent
          );
          channel.bind(
            PUSHER_EVENTS.INBOX_MESSAGE_DELETE_STATUS,
            this.messageDeleteStatusEvent
          );
          channel.bind(
            PUSHER_EVENTS.INBOX_MESSAGE_REMOVED,
            this.messageRemoveEvent
          );
          channel.bind(
            PUSHER_EVENTS.INBOX_MESSAGE_REACTION,
            this.handleMessageReaction
          );
        }
        channel.bind(
          PUSHER_EVENTS.ACCOUNT_BLOCKED,
          this.policyEnforcementMessageEvent
        );
        channel.bind(
          PUSHER_EVENTS.ACCOUNT_UNBLOCKED,
          this.policyEnforcementMessageEvent
        );
        channel.bind(
          PUSHER_EVENTS.WARNING_RECEIVED,
          this.policyEnforcementMessageEvent
        );
      })
      .catch((error) => {
        console.warn("Inbox pusher subscription failed", error);
      });
  }

  public static getInstance(user: User): PusherClient {
    if (!PusherClient.#instance && user && user.adminId) {
      PusherClient.#instance = new PusherClient(user);
    }
    return PusherClient.#instance;
  }

  handleMessageReaction = (message: ReactionPayload): void => {
    console.log("message-reaction from PusherClient", message);
    if (message.action === "added") {
      Store.dispatch(addMessageReactionSuccess(message));
    } else {
      Store.dispatch(removeMessageReactionSuccess(message));
    }
  };

  newMessageAddedEvent = (message: AddMessageAction["payload"]): void => {
    Store.dispatch(addMessage(message));
  };

  messageRemoveEvent = (message: RemoveMessageAction["payload"]): void => {
    console.log("messageRemoveEvent from PusherClient", message);
    Store.dispatch(removeMessage(message));
  };

  messageDeleteStatusEvent = (
    message: DeleteMessageStatusAction["payload"]
  ): void => {
    console.log("messageDeleteStatusEvent from PusherClient", message);
    Store.dispatch(deleteMessageStatus(message));
  };

  policyEnforcementMessageEvent = (payload: PolicyEnforcementPayload): void => {
    Store.dispatch(
      updateAccount(payload.accountId, {
        policyEnforcementStatus: payload.status,
        policyEnforcementInfo: payload.message,
      })
    );
  };
}
